import { generateClassNames } from '@staticcms/core/lib/util/theming.util';

const mobileCollectionControlsClasses = generateClassNames('MobileCollectionControls', [
  'root',
  'content',
  'toggle',
]);

export default mobileCollectionControlsClasses;
